import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TransactionSource } from '../models/invoice/payment.model';
import { GooglePayment } from 'src/app/shared/models/invoice/google-payment.model';

@Injectable({
  providedIn: 'root',
})
export class GooglePaymentService {
  private baseRoute: string;

  constructor(private httpClient: HttpClient) {
    this.baseRoute = environment.paymentAPIRoot;
  }

  charge<T>(payload: GooglePayment): Observable<T> {
    return this.httpClient.post<T>(
      `${this.baseRoute}/api/googlepay/charge?userId=1&locationId=${payload.paymentMethodData.info.locationId}`,
      payload
    );
  }

  chargeOnly<T>(payload: GooglePayment): Observable<T> {
    console.log(payload);
    payload.paymentMethodData.info.mid =
      payload.paymentMethodData.info.mid.substring(3);
    return this.httpClient.post<T>(
      `${this.baseRoute}/api/googlepay/chargeonly?userId=1&locationId=${payload.paymentMethodData.info.locationId}`,
      payload
    );
  }
}
